import { render } from "./cartBox.vue?vue&type=template&id=0250a8b3"
import script from "./cartBox.vue?vue&type=script&lang=js"
export * from "./cartBox.vue?vue&type=script&lang=js"

import "./cartBox.vue?vue&type=style&index=0&id=0250a8b3&lang=css"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__